"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPaymentDetails = exports.paymentDetailsSlice = exports.fetchPaymentDetails = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const initialState = {
  paymentDetails: [],
  activeOrBoundPaymentDetails: [],
  loading: true,
  error: null
};
const fetchPaymentDetails = exports.fetchPaymentDetails = (0, _toolkit.createAsyncThunk)('paymentDetails', async (_, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    return await (0, _api.getPaymentDetails)();
  } catch (error) {
    const typedError = error;
    return rejectWithValue(typedError.message);
  }
});
const paymentDetailsSlice = exports.paymentDetailsSlice = (0, _toolkit.createSlice)({
  name: 'paymentDetails',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchPaymentDetails.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchPaymentDetails.fulfilled, (state, _ref2) => {
      let {
        payload
      } = _ref2;
      state.loading = false;
      state.paymentDetails = payload === null || payload === void 0 ? void 0 : payload.paymentDetails;
      state.activeOrBoundPaymentDetails = payload === null || payload === void 0 ? void 0 : payload.paymentDetails.filter(item => item.active || item.bound);
    });
    builder.addCase(fetchPaymentDetails.rejected, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.error = action.payload;
      }
    });
  }
});
const selectPaymentDetails = state => state.paymentDetails;
exports.selectPaymentDetails = selectPaymentDetails;
var _default = exports.default = paymentDetailsSlice.reducer;